export class CPPReturnsItemsFilter {
  itemNo: string;
  clearAll: boolean;
  productName: string;
  packageSize: string;
  vendorName: string;
  productLine: string;
  activeIngredient: string;
  gtin: string;
  conLotNumber: string;
  conItemNumber: string;
  conPackageSize: string;
  productLineIds: string;
}
